const MUSIC_OPEN_CUSTOM_EVENT = "music-open";
const MUSIC_CLOSE_CUSTOM_EVENT = "music-close";

class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    this.announcementBar = this.querySelector(".announcement-bar");
    this.header = this.querySelector(".mega-menu");

    this.headerState = "inactive";
    this.megaMenuState = "inactive";
    this.searchState = "inactive";

    this.menuItems = this.querySelectorAll("[data-mega-menu]");
    this.megaMenuContainer = this.querySelector(".mega-menu-container");
    this.megaMenus = this.querySelectorAll("[data-for-menu]");
    this.menuLinks = this.querySelectorAll(".menu-link");

    this.overlay = this.querySelector(".mega-menu-overlay");
    this.musicButton = this.querySelector(".music-button");

    this.searchBtn = this.querySelector(".search.desktop-only");
    this.searchResultsContainer = document.querySelector(".predictive-search-container");
    this.headerSearchInput = document.querySelector(".predictive-search-container #header-search");
  }

  connectedCallback() {
    if (this.header.dataset.scroll === "enabled") this.attachScrollEvent();

    this.menuItems.forEach((item, i) => {
      item.addEventListener("mouseenter", () =>
        this.onMenuItemHover(item?.dataset?.megaMenu)
      );
      item.addEventListener("click", () =>
        this.onMenuItemClick({
          dataset: item?.dataset?.megaMenu,
          index: i,
        })
      );
    });

    this.menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        this.setHeaderState("inactive");
        this.setSearchMenu("inactive");
      });
    });

    this.overlay.addEventListener("click", () => {
      this.setHeaderState("inactive");
      this.setSearchMenu("inactive");
    });
    this.overlay.addEventListener("mouseenter", () => {
      this.setHeaderState("inactive");
      this.setSearchMenu("inactive");
    });

    this.searchBtn.addEventListener("click", () => this.setSearchMenu());

    if (this.musicButton) {
      this.musicButton.addEventListener("click", this.onMusicClick.bind(this));
    }

    this.onMatchMedia();
  }

  /**
   * Sets the state of the header component.
   *
   * @param {"active" | "inactive"} state - The desired scroll state of the header. Can be either "active" or "inactive".
   */
  setHeaderState(state) {
    if (state !== "active" && state !== "inactive") {
      console.error(
        "Invalid state. State must be either 'active' or 'inactive'."
      );
      return;
    }

    if (state === "active") {
      this.header.classList.add("active");
      if (this.searchState === "active") {
        this.megaMenuContainer.classList.add("active", "instant");
      } else {
        this.megaMenuContainer.classList.add("active");
      }

      this.overlay.classList.add("active");
      this.announcementBar?.classList.add("active");
    } else {
      this.setMegaMenu("inactive");
      this.header.classList.remove("active");
      this.overlay.classList.remove("active");
      this.announcementBar?.classList.remove("active");
    }

    this.headerState = state;
  }

  onMenuItemClick({ dataset: megaMenuData, index }) {
    if (this.menuItems[index]?.classList.contains("active")) {
      this.setHeaderState("inactive");
    } else {
      if (this.headerState === "inactive") this.setHeaderState("active");
      this.setSearchMenu("inactive");
      this.setMegaMenu(megaMenuData);
    }
  }

  onMenuItemHover(megaMenuData) {
    this.setHeaderState("active");
    this.setSearchMenu("inactive");
    this.setMegaMenu(megaMenuData);
  }

  setMegaMenu(megaMenuData) {
    if (megaMenuData === "inactive") {
      this.megaMenuContainer.classList.remove("active", "instant");
      this.menuItems.forEach((item) => item.classList.remove("active"));
      this.megaMenus.forEach((menu) => menu.classList.remove("active"));
      this.megaMenuState = "inactive";
      return;
    } else {
      this.megaMenuState = "active";
    }

    this.menuItems.forEach((item) => {
      if (item.dataset.megaMenu === megaMenuData) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });

    this.megaMenus.forEach((menu) => {
      if (menu.dataset.forMenu === megaMenuData) {
        menu.classList.add("active");
      } else {
        menu.classList.remove("active");
      }
    });
  }

  /**
   * Sets the state of the search results component.
   *
   * @param {"active" | "inactive" | undefined} state
   */
  setSearchMenu(state) {
    if (
      state === "inactive" ||
      (typeof state === "undefined" &&
        this.searchResultsContainer.classList.contains("active"))
    ) {
      this.searchResultsContainer.classList.remove("active", "instant");
      if (
        window.scrollY <= 32 &&
        this.header.classList.contains("should-use-transparency") &&
        this.headerState !== "active"
      ) {
        this.header.classList.add("transparent");
      }
      this.searchState = "inactive";
      this.headerSearchInput.value = '';
    } else {
      this.header.classList.remove("transparent");
      this.overlay.classList.add("active");
      if (this.megaMenuState === "active") {
        this.searchResultsContainer.classList.add("active", "instant");
      } else {
        this.searchResultsContainer.classList.add("active");
      }
      this.setMegaMenu("inactive");
      this.searchState = "active";
      this.headerSearchInput.focus();
    }
  }

  onMatchMedia() {
    this.mql = window.matchMedia("(max-width: 1199.98px)");
    this.mql.onchange = (e) => {
      if (e.matches) {
        this.setHeaderState("inactive");
        this.setSearchMenu("inactive");
      }
    };
  }

  attachScrollEvent() {
    window.addEventListener("scroll", this.onScroll.bind(this));
  }

  onScroll() {
    if(!this.searchResultsContainer.classList.contains("active")) {
      if (this.announcementBar) {
        window.scrollY <= 32
          ? this.header.classList.add("transparent")
          : this.header.classList.remove("transparent");
      } else {
        this.header.classList.toggle("transparent", window.scrollY === 0);
      }
    } else {
      this.header.classList.remove("transparent");
    }
  }

  onMusicClick() {
    document.dispatchEvent(new CustomEvent(MUSIC_OPEN_CUSTOM_EVENT));
  }
}

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector(".mega-menu");
    this.announcementBar = this.querySelector(".announcement-bar");
    this.headerState = "inactive";

    this.isMenuOpen = false;
    this.openBtn = this.querySelector(".menu-open-btn");
    this.closeBtn = this.querySelector(".menu-close-btn");
    this.menu = this.querySelector(".mobile-menu-container");

    this.isSearchOpen = false;
    this.searchBtn = this.querySelector(".search.mobile-only");
    // this.searchMenu = this.querySelector(".mobile-search-results-container");
    this.searchMenu = document.querySelector(".predictive-search-container");
    this.headerSearchInput = document.querySelector(".predictive-search-container #header-search");

    this.megaMenuControls = this.querySelector(".mega-menu-controls");
    this.menuLogo = this.querySelector(".menu-logo-container");
    this.menuTabsWrapper = this.querySelector(".mobile-top-links-wrapper");

    this.menuItems = this.querySelectorAll(".mobile-menu-item");
    this.menuButtons = this.querySelectorAll(".mobile-menu-expand-btn");
  }

  connectedCallback() {
    this.openBtn.addEventListener("click", this.toggleMenu.bind(this));
    this.searchBtn.addEventListener("click", this.toggleSearch.bind(this));
    this.closeBtn.addEventListener("click", () => {
      this.closeMenu();
      this.closeSearch();
    });

    this.menuButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.toggleExpandMenu(btn.dataset.index, btn.offsetHeight);
      });
    });

    this.onMatchMedia();
  }

  toggleMenu() {
    this.isMenuOpen ? this.closeMenu() : this.openMenu();
  }

  toggleSearch() {
    this.isSearchOpen ? this.closeSearch() : this.openSearch();
  }

  openMenu() {
    // Disable scroll when quiz is opened
    document.body.style.overflow = "hidden";
    this.openBtn.classList.remove("active");
    this.closeBtn.classList.add("active");

    this.megaMenuControls.classList.add("hidden");
    this.menuLogo.classList.add("mobile-active");
    this.setHeaderState("active");
    this.menu.classList.add("active");
    this.announcementBar?.classList.add("mobile-active");
    this.isMenuOpen = true;
  }

  closeMenu() {
    // Enable scroll when quiz is opened
    document.body.style.overflow = "auto";
    this.openBtn.classList.add("active");
    this.closeBtn.classList.remove("active");

    this.menu.classList.remove("active");
    this.setHeaderState("inactive");
    this.megaMenuControls.classList.remove("hidden");
    this.menuLogo.classList.remove("mobile-active");
    this.announcementBar?.classList.remove("mobile-active");
    this.isMenuOpen = false;
  }


  openSearch() {
    // Enable scroll when quiz is opened
    document.body.style.overflow = "hidden";
    this.openBtn.classList.remove("active");
    this.closeBtn.classList.add("active");
    this.searchBtn.classList.add("active");

    this.megaMenuControls.classList.add("hidden");
    this.menuLogo.classList.add("mobile-active");
    this.setHeaderState("active");
    this.searchMenu.classList.add("active");
    this.announcementBar?.classList.add("mobile-active");
    this.isSearchOpen = true;
    
    this.headerSearchInput.focus();
  }


  closeSearch() {
    document.body.style.overflow = "auto";
    this.openBtn.classList.add("active");
    this.closeBtn.classList.remove("active");
    this.searchBtn.classList.remove("active");

    this.searchMenu.classList.remove("active");
    this.setHeaderState("inactive");
    this.megaMenuControls.classList.remove("hidden");
    this.menuLogo.classList.remove("mobile-active");
    this.announcementBar?.classList.remove("mobile-active");
    this.isSearchOpen = false;
    this.headerSearchInput.value = '';
  }

  /**
   * Sets the state of the header component.
   *
   * @param {"active" | "inactive"} state - The desired scroll state of the header. Can be either "active" or "inactive".
   */
  setHeaderState(state) {
    if (state !== "active" && state !== "inactive") {
      console.error(
        "Invalid state. State must be either 'active' or 'inactive'."
      );
      return;
    }

    if (state === "active") {
      this.header.classList.add("active");
    } else {
      this.header.classList.remove("active");
    }

    this.headerState = state;
  }

  onMatchMedia() {
    this.mql = window.matchMedia("(max-width: 1199.98px)");
    this.mql.onchange = (e) => {
      if (!e.matches) {
        this.closeMenu();
        this.closeSearch();
        window.removeEventListener("resize", this.onResize.bind(this));
      } else {
        window.addEventListener("resize", this.onResize.bind(this));
      }
    };
  }

  onResize() {
    this.menuTabsWrapper
      .querySelectorAll(".mobile-menu-item.as-tab.active")
      .forEach((item) => {
        item.style.maxHeight = `${item.scrollHeight}px`;
      });
  }

  toggleExpandMenu(index, btnHeight) {
    this.menuItems.forEach((item) => {
      if (item.dataset.index === index) {
        if (item.classList.contains("active")) {
          item.style.maxHeight = `${btnHeight}px`;
          item.classList.remove("active");
        } else {
          item.style.maxHeight = `${item.scrollHeight}px`;
          item.classList.add("active");
        }
      } else {
        item.classList.remove("active");
        item.style.maxHeight = `${btnHeight}px`;
      }
    });
  }
}

class MusicPanel extends HTMLElement {
  constructor() {
    super();
    this.musicEvents = {
      open: MUSIC_OPEN_CUSTOM_EVENT,
      close: MUSIC_CLOSE_CUSTOM_EVENT,
    };
    this.musicContainer = this.querySelector(".pretty-green-music");
    this.closeBtn = this.querySelector(".close-music-btn");
    
    
    this.shouldShowMusicPanel = true
    this.initializeMusicPanelCookie();

    
  }

  connectedCallback() {
    if (this.musicContainer.classList.contains("open-automatically") && this.shouldShowMusicPanel != false )
      this.automaticOpen();
      this.closeBtn.addEventListener("click", this.closePanel.bind(this));

    document.addEventListener(this.musicEvents.open, () => {
      this.openPanel();
    });

    document.addEventListener(this.musicEvents.close, () => {
      this.closePanel();
    });
  }

  async automaticOpen() {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    this.openPanel();
  }

  closePanel() {
    this.musicContainer.classList.remove("active");
    
    this.closeMusicPanelCookie()
  }

  openPanel() {
    this.musicContainer.classList.add("active");
  }
  


    // Initialization method to set or retrieve the cookie state
    initializeMusicPanelCookie() {
      let storedValue = this.getCookie('pgm-should-show');
      this.shouldShowMusicPanel = storedValue === 'true' || storedValue === null; // Default to true if no cookie
      
      // If cookie does not exist (first visit), set it to true
      if (storedValue === null) {
          this.shouldShowMusicPanel = true;
          this.setCookie('pgm-should-show', this.shouldShowMusicPanel, 30); // Set cookie for 1 year
          // console.log('🎤 COOKIE SET TO TRUE ON INITIAL LOAD');
      } else {
          // console.log('🎤 COOKIE FOUND: ', storedValue);
      }
  }

  // Method to simulate closing the banner
  closeMusicPanelCookie() {
    this.shouldShowMusicPanel = false;
    this.setCookie('pgm-should-show', this.shouldShowMusicPanel, 30); // Update cookie to false for 1 year
    // console.log('🎤 MUSIC BANNER SHOULD SHOW AFTER CLOSE: ', this.shouldShowMusicPanel);
  }
  
  // Method to set a cookie
  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }
  
  // Method to get a cookie
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
}

if (!window.customElements.get("header-component")) {
  window.customElements.define("header-component", HeaderComponent);
}

if (!window.customElements.get("mobile-menu")) {
  window.customElements.define("mobile-menu", MobileMenu);
}

if (!window.customElements.get("music-panel")) {
  window.customElements.define("music-panel", MusicPanel);
}
